import { render, staticRenderFns } from "./quizModulePageNew1.vue?vue&type=template&id=3fb57f62&scoped=true&"
import script from "./quizModulePageNew1.vue?vue&type=script&lang=js&"
export * from "./quizModulePageNew1.vue?vue&type=script&lang=js&"
import style0 from "./quizModulePageNew1.vue?vue&type=style&index=0&id=3fb57f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb57f62",
  null
  
)

export default component.exports